import claudio_y_jasna from "../media/art/claudio_y_jasna.jpg";
import in_gods_iris from "../media/art/in_gods_iris.jpg";
import into_the_vanity from "../media/art/into_the_vanity.jpg";
import textures_and_colors from "../media/art/textures_and_colors.jpg";
import time from "../media/art/time.jpg";

// export const tabNames = ["Home", "Code", "Art", "Writing"];

export const artInfo = [
	{
		name: "In God's Iris",
		src: in_gods_iris,
		medium: "Oil on Canvas",
		date: "June 2020",
		class: "landscape"
	},
	{
		name: "Time",
		src: time,
		medium: "Pencil on Paper",
		date: "March 2018",
		"class": "landscape"
	},
	{
		name: "Into the Vanity",
		src: into_the_vanity,
		medium: "Pencil on Paper",
		date: "June 2020",
		class: "landscape"
	},
	{
		name: "Claudio y Jasna",
		src: claudio_y_jasna,
		medium: "Pencil on Paper",
		date: "September 2018",
		class: "landscape"
	},
	{
		name: "Textures And Optical Colors",
		src: textures_and_colors,
		medium: "Colored Pens on Paper",
		date: "October 2018",
		class: "landscape"
	}
]